export default "skymp5-front/b6e3117d72828a530f4991b6dff219ab.jpg";